// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---docz-index-mdx": () => import("./../../../../docz/index.mdx" /* webpackChunkName: "component---docz-index-mdx" */),
  "component---docz-usage-mdx": () => import("./../../../../docz/usage.mdx" /* webpackChunkName: "component---docz-usage-mdx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

